import * as Yup from "yup";
/**
 * Dynamically builds a Yup validation schema from the form schema config.
 * Handles required fields, email format, phone format, and conditional fields.
 */
export const FIELD_TYPES = {
  TEXT: "text",
  EMAIL: "email",
  TEL: "number",
  TEXTAREA: "textarea",
  SELECT: "select",
  FILE_UPLOAD: "file_upload",
  RADIO: "radio",
};

export const buildValidationSchema = (sections) => {
  const shape = {};

  sections.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.type === FIELD_TYPES.FILE_UPLOAD) return;

      let validator;

      switch (field.type) {
        case FIELD_TYPES.EMAIL:
          validator = Yup.string().email("Please enter a valid email address");
          break;

        case FIELD_TYPES.TEL:
          validator = Yup.string().matches(
            /^[6-9]\d{9}$/,
            "Please enter a valid mobile number"
          )
          .min(10, "Must be exactly 10 digits")
          .max(10, "Must be exactly 10 digits");
          break;

        case FIELD_TYPES.RADIO:
          validator = Yup.string();
          break;

        default:
          validator = Yup.string();
      }

      if (field.maxLength) {
        validator = validator.max(
          field.maxLength,
          `${field.label} must be at most ${field.maxLength} characters`
        );
      }

      // Conditional fields — only required when dependency is met
      if (field.dependsOn) {
        const { field: depField, value: depValue } = field.dependsOn;
        if (field.required) {
          validator = validator.when(depField, {
            is: depValue,
            then: validator.required(`${field.label} is required`),
            otherwise: validator.notRequired(),
          });
        } else {
          validator = validator.notRequired();
        }
      } else if (field.required) {
        validator = validator.required(`${field.label} is required`);
      } else {
        validator = validator.notRequired();
      }

      shape[field.id] = validator;
    });
  });

  return Yup.object().shape(shape);
};

/**
 * Builds flat initial values object from the form schema.
 */
export const buildInitialValues = (sections) => {
  const values = {};

  sections.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.type === FIELD_TYPES.FILE_UPLOAD) return;
      values[field.id] = "";
    });
  });

  return values;
};
